export default function(selector) {
  return function() {
    return this.matches(selector);
  };
}



// WEBPACK FOOTER //
// C:/Dropbox/www/amcharts4dev/node_modules/d3-selection/src/matcher.js